/**
 * LES DOCUMENTS D'UNE MAINTENANCE — vocabulaire des types, côté écran (28/10/2026).
 *
 * ⚠️ MIROIR de `backend/src/documents-maintenance.ts` : le serveur refuse tout type
 * hors de cette liste, l'écran la propose. Le test `front-documents-maintenance`
 * compare les deux. Module PUR.
 */
export const TYPES_DOCUMENT = [
  { k: 'rapport', label: 'Rapport d’intervention' },
  { k: 'bon', label: 'Bon d’intervention' },
  { k: 'devis', label: 'Devis' },
  { k: 'commande', label: 'Bon de commande' },
  { k: 'facture', label: 'Facture' },
  { k: 'verification', label: 'PV de vérification / contrôle' },
  { k: 'certificat', label: 'Certificat / attestation' },
  { k: 'photo', label: 'Photo' },
  { k: 'autre', label: 'Autre document' },
] as const;

export type TypeDocument = (typeof TYPES_DOCUMENT)[number]['k'];

/** « Type non précisé » est un ÉTAT à voir : les fichiers joints avant le 28/10/2026 n'en ont pas. */
export function libelleTypeDocument(k: unknown): string {
  return TYPES_DOCUMENT.find((t) => t.k === String(k ?? ''))?.label ?? 'Type non précisé';
}
